import { createBrowserRouter, Navigate } from 'react-router-dom';

import { privateRoutes } from './routes/private-routes';
import { publicRoutes } from './routes/public-routes';
import { PrivateOutlet } from './routing/private-outlet';
import { PublicOutlet } from './routing/public-outlet';
import { ErrorPage } from '@pages/public/error';
import { Routes } from '@shared/constants/routes';
import { getDefaultOrganizationRoute } from '@shared/lib/permissions';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';

const DefaultPrivateRedirect = () => {
  const isAuthorized = useAppSelector(authSelectors.selectIsAuthorized);
  const userInfo = useAppSelector(authSelectors.selectUserInfo);
  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);

  const fallbackOrganization =
    currentOrganization.id !== 0 ? currentOrganization : userInfo?.organizations?.[0];

  if (!isAuthorized) {
    return <Navigate to={Routes.analytics.root} replace />;
  }

  return (
    <Navigate
      to={getDefaultOrganizationRoute(fallbackOrganization?.permission, fallbackOrganization?.id)}
      replace
    />
  );
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DefaultPrivateRedirect />,
  },
  {
    element: <PrivateOutlet />,
    errorElement: <ErrorPage />,
    children: privateRoutes,
  },
  {
    element: <PublicOutlet />,
    errorElement: <ErrorPage />,
    children: publicRoutes,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
]);
